<template>
    <div class="l-auth">
        <y-container>
            <div class="l-auth-logo">
                <router-link :to="{ name: 'home' }">
                    <img
                        v-if="$settings('site_logos.header')"
                        :src="$settings('site_logos.header.link')"
                        :alt="$settings('site_title.site_title')"
                        class="l-auth-logo__img"
                    >
                </router-link>
            </div>
        </y-container>
        <slot />

        <y-loading
            :active="$wait.is('loading-page')"
            :type="$configs.project.loadingMode"
            :color="$configs.project.loadingColor"
            size="60"
            height="100vh"
        />
    </div>
</template>

<script>
    export default {
        name: 'AuthLayout',
    };
</script>

